<script>
/* eslint-disable no-underscore-dangle */


import { isNil, min, max, isEmpty, isFunction, debounce } from 'lodash';
import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import TimerMixin from '../../../mixins/TimerMixin';
import Icon from '../util/Icon';

export default {
  name: 'SourceIcon',

  mixins: [HotelmeisterMixin, TimerMixin],

  props: {
    source: {
      required: true,
      type: String,
      default: null,
    },
  },

  computed: {
    lowerCaseSource: function () {
      if (isEmpty(this.source)) return null;
      else return this.source.toLowerCase();
    },
    icon: function () {
      if (isEmpty(this.lowerCaseSource)) return 'channel';
      else if (this.lowerCaseSource.indexOf('hrs') === 0) return 'hrs';
      else if (this.lowerCaseSource.includes('expedia')) return 'expedia';
      else if (this.lowerCaseSource.includes('airbnb')) return 'airbnb';
      else if (this.lowerCaseSource.includes('feratel')) return 'feratel';
      else if (this.lowerCaseSource.includes('website')) return 'website';
      else if (this.lowerCaseSource.includes('hotelmeister ibe')) return 'website';
      else if (this.lowerCaseSource.includes(this.hotelSettings.hotel.whiteLabel.toLowerCase())) return 'website';
      else if (this.lowerCaseSource.includes('traum') && this.lowerCaseSource.includes('ferienwohnungen')) return 'traumferienwohnungen';
      else if (this.lowerCaseSource.includes('booking.com') || this.lowerCaseSource.indexOf('booking') === 0) return 'booking';
      else return 'channel';
    },
  },

  render: function (createElement) {
    return createElement(Icon, {
      props: {
        icon: `roomplan-${this.icon}`,
      },
      style: {
        marginLeft: '0.2rem',
      },
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/lib/roomplan/SourceIcon.vue